// extracted by mini-css-extract-plugin
module.exports = {"searchFeed":"SearchFeed_searchFeed__17zT6","searchFeed_videosHeading":"SearchFeed_searchFeed_videosHeading__40ayx"};